<template lang='pug'>
div(v-if='atLeastOneUTMTag()')
  div.utm-icon(:id='"utm-icon-" + rowId')
    font-awesome-icon(icon='tags')
  b-popover(:target='"utm-icon-" + rowId' triggers='hover' placement='left' boundary-padding='50')
    table
      tr(v-for='tag in possibleUtmTags')
        td.pr-4 utm_{{ tag.toLowerCase() }}
        td {{ utmTags["utm_" + tag] }}
</template>

<script>
export default {
  props: {
    // Type declarations in vue are sus so the type is not really specified here
    // but we expect this object to have fields like utm_content, utm_source, etc.
    utmTags: {
      type: Object,
      required: true
    },
    rowId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      possibleUtmTags: ['source', 'medium', 'campaign', 'term', 'content']
    }
  },

  methods: {
    atLeastOneUTMTag() {
      return this.possibleUtmTags.some((tag) =>
        this.$props.utmTags['utm_' + tag] !== null &&
        this.$props.utmTags['utm_' + tag] !== undefined
      )
    }
  }
}
</script>
